import { hasPermission } from "@nimbus-erp/shared";
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "../store/authStore";

export function PermissionGate({
  permission,
  children,
}: {
  permission: string;
  children: ReactNode;
}) {
  const user = useAuthStore((state) => state.user);
  if (!user || !hasPermission(user.permissions, permission))
    return <Navigate to="/403" replace />;
  return children;
}
